import React from "react";

function GenderAvatar({
  src,
  gender,
  alt = "img",
  width = 100,
  height = 80,
  onClick,
  className = "",
  showTag = false,
}) {
  const normalized = String(gender || "").toLowerCase();
  const isMale = normalized === "male";
  const isFemale = normalized === "female";
  const label = isMale ? "Male" : isFemale ? "Female" : "";

  return (
    <div
      className={`mc-gender-avatar ${
        isMale ? "is-male" : isFemale ? "is-female" : ""
      } ${className}`}
      style={{ width, height }}
    >
      <img
        src={src}
        alt={alt}
        width={width}
        height={height}
        className="rounded mc-gender-avatar__img"
        onClick={onClick}
      />
      {showTag && label ? (
        <span className="mc-gender-tag" aria-label={label}>
          {label}
        </span>
      ) : null}
    </div>
  );
}

export default GenderAvatar;
